'use strict';

var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var errCode = require('err-code');

var _require = require('buffer'),
    Buffer = _require.Buffer;

var log = require('debug')('ipfs:mfs:utils:to-async-iterator');

var _require2 = require('../../../utils'),
    MFS_MAX_CHUNK_SIZE = _require2.MFS_MAX_CHUNK_SIZE;

var toAsyncIterator = function toAsyncIterator(content) {
  if (!content) {
    throw errCode(new Error('paths must start with a leading slash'), 'ERR_INVALID_PATH');
  }

  if (typeof content === 'string' || content instanceof String) {
    log('Content was a string');
    content = Buffer.from(content);
  }

  if (content.length) {
    log('Content was array-like');
    return _defineProperty({}, Symbol.asyncIterator, /*#__PURE__*/_regeneratorRuntime.mark(function bufferContent() {
      return _regeneratorRuntime.wrap(function bufferContent$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return content;

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, bufferContent);
    }));
  }

  if (content[Symbol.asyncIterator]) {
    log('Content was an async iterator');
    return content;
  }

  if (content[Symbol.iterator]) {
    log('Content was an iterator');
    return content;
  }

  if (global.Blob && content instanceof global.Blob) {
    // HTML5 Blob objects (including Files)
    log('Content was an HTML5 Blob');
    var index = 0;
    var iterator = {
      next: function next() {
        if (index > content.size) {
          return {
            done: true
          };
        }

        return new Promise(function (resolve, reject) {
          var chunk = content.slice(index, MFS_MAX_CHUNK_SIZE);
          index += MFS_MAX_CHUNK_SIZE;
          var reader = new global.FileReader();

          var handleLoad = function handleLoad(ev) {
            reader.removeEventListener('loadend', handleLoad, false);

            if (ev.error) {
              return reject(ev.error);
            }

            resolve({
              done: false,
              value: Buffer.from(reader.result)
            });
          };

          reader.addEventListener('loadend', handleLoad);
          reader.readAsArrayBuffer(chunk);
        });
      }
    };
    return _defineProperty({}, Symbol.asyncIterator, function () {
      return iterator;
    });
  }

  throw errCode(new Error("Don't know how to convert ".concat(content, " into an async iterator")), 'ERR_INVALID_PARAMS');
};

module.exports = toAsyncIterator;